import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';

import { ConfigGuard } from '@occc-app/App/guards';
import { Can } from '@occc-app/App/PolicyBasedAccessControl/components/Can';
import { ReadRetailerNetworkUsers } from '@occc-app/App/PolicyBasedAccessControl/userActions';
import UnauthorizedPage from '@occc-app/routes/Unauthorized';

type RetailerNetworkUserDetailsPageGuardProps = {
  children: ReactNode;
};

export const RetailerNetworkUserDetailsPageGuard = ({
  children,
}: RetailerNetworkUserDetailsPageGuardProps) => {
  const { networkId = '' } = useParams<{ networkId: string }>();

  return (
    <ConfigGuard isFeatureEnabled={(config) => !!config.retailerConnect?.enabled}>
      <Can I={ReadRetailerNetworkUsers({ uuid: networkId })} fallback={<UnauthorizedPage />}>
        {children}
      </Can>
    </ConfigGuard>
  );
};
